export default __webpack_public_path__ + "static/media/Stop.5613deac.svg";